import { reactive, computed } from 'vue'
import { apiEffectiveScanSelectRecord } from '@/api/workPlace/retreatment'

export default function useScanHooks(prop) {
  const recordCusMap = reactive({
    completeReserveActionRecordList: [],
    effectiveScanQueryResponseList: []
  })

  const doctorInfo = computed(() => prop.workOrderGroupInfo.doctorInfo)
  const patientInfo = computed(() => prop.workOrderGroupInfo.patientInfo)
  const targetOrder = computed(() => prop.workOrderGroupInfo.targetWorkOrder)

  const FormatFiledName = (array, cValue, cLabel) => {
    return array.map(item => {
      return {
        ...item,
        value: item[cValue] + '',
        label: item[cLabel]
      }
    })
  }

  const getRecordDayly = () => {
    apiEffectiveScanSelectRecord({
      ucDoctorId: doctorInfo.value.ucUserId,
      ucPatientId: patientInfo.value.ucUserId,
      defaultDate: targetOrder.value.createAt
    }).then(res => {
      const { completeReserveActionRecordList, effectiveScanQueryResponseList } = res
      recordCusMap.completeReserveActionRecordList = FormatFiledName(
        completeReserveActionRecordList,
        'completeCureActionId',
        'reserveActionRecord'
      )
      recordCusMap.effectiveScanQueryResponseList = FormatFiledName(
        effectiveScanQueryResponseList,
        'scanId',
        'scanRecord'
      )
    })
  }

  return {
    recordCusMap,
    getRecordDayly
  }
}
